import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const useProductGroups = (enabled?: boolean) => {
  const api = useAPI();

  return useQuery({
    queryKey: ['product-groups'],
    queryFn: () =>
      api
        .postBackItemsItemTypeTagsListFilter({
          postBackItemsItemTypeTagsListFilterRequest: {
            data: {},
          },
        })
        .then((res) => res.result.data),
    enabled,
  });
};
